'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPane = exports["default"] = undefined;

var _Tabs = require('./Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

var _TabPane2 = require('./TabPane');

var _TabPane3 = _interopRequireDefault(_TabPane2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Tabs2["default"];
exports.TabPane = _TabPane3["default"];


//////////////////
// WEBPACK FOOTER
// ./~/.7.3.1@rc-tabs/lib/index.js
// module id = 532
// module chunks = 0